import PageHero from "@/components/PageHero"
import { useScrollReveal } from "@/hooks/useScrollReveal"
import {Heart, Shield, Zap, Users, BookOpen, Star} from 'lucide-react'

const valores = [
  {
    icon: Heart,
    title: "Acessibilidade",
    text: "Acreditamos que o inglês deve ser acessível a todos. Trabalhamos para derrubar barreiras financeiras e geográficas no aprendizado do idioma.",
    color: "#B038B2",
  },
  {
    icon: Zap,
    title: "Inovação",
    text: "Utilizamos tecnologia de ponta — inteligência artificial, aplicativos e plataformas digitais — para criar experiências de aprendizado modernas e eficientes.",
    color: "#0E8EA0",
  },
  {
    icon: Users,
    title: "Respeito ao aluno",
    text: "Cada aluno tem sua rotina, seu tempo e seu ritmo. Nossas soluções são pensadas para se adaptar à vida real, não o contrário.",
    color: "#F5C542",
  },
  {
    icon: Shield,
    title: "Compromisso com resultados",
    text: "Não vendemos promessas. Entregamos metodologia estruturada, suporte contínuo e ferramentas que geram evolução real e mensurável.",
    color: "#B038B2",
  },
  {
    icon: BookOpen,
    title: "Educação contínua",
    text: "O aprendizado não termina em um curso. Desenvolvemos ecossistemas de aprendizagem que acompanham o aluno em toda sua jornada.",
    color: "#0E8EA0",
  },
  {
    icon: Star,
    title: "Impacto social",
    text: "Acreditamos no poder transformador da educação. Investimos em projetos sociais e iniciativas que levam o inglês a comunidades que mais precisam.",
    color: "#F5C542",
  },
]

export default function Valores() {
  const section1 = useScrollReveal()

  return (
    <>
      <PageHero
        title="Valores Organizacionais"
        subtitle="Os princípios que guiam cada decisão, cada produto e cada interação da English Work."
      />

      <section className="py-20 bg-white">
        <div
          ref={section1.ref}
          className={`max-w-5xl mx-auto px-5 transition-all duration-700 ${section1.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <p className="text-center text-gray-600 max-w-2xl mx-auto mb-14 leading-relaxed">
            Na English Work, nossos valores não são apenas palavras em um mural. Eles orientam como criamos nossos produtos, como tratamos nossos alunos e como impactamos a sociedade.
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {valores.map((item) => (
              <div
                key={item.title}
                className="bg-white rounded-2xl p-8 border border-gray-100 hover:shadow-lg transition-all duration-300 group"
              >
                <div
                  className="w-14 h-14 rounded-xl flex items-center justify-center mb-5 transition-transform duration-300 group-hover:scale-110"
                  style={{ backgroundColor: `${item.color}15` }}
                >
                  <item.icon size={26} style={{ color: item.color }} />
                </div>
                <h3 className="text-lg font-bold mb-3 text-gray-900">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
